const variants = {
  protected:
    "bg-emerald-700 text-white hover:bg-emerald-800 shadow-sm focus:ring-2 focus:ring-emerald-100",
  dark: "bg-black text-white hover:bg-slate-800",
  plain: "",
};

const LoadingButton = ({
  loading,
  children,
  variant = "protected",
  className = "",
  ...props
}) => {
  return (
    <button
      disabled={loading}
      className={`px-4 py-2 rounded-xl w-full flex justify-center items-center font-semibold transition ${
        variants[variant] || variants.protected
      } ${
        loading ? "opacity-75 cursor-not-allowed" : ""
      } ${className}`}
      {...props}
    >
      {loading ? (
        <svg
          className="animate-spin h-5 w-8 text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            className="opacity-75"
            fill="currentColor"
            d="M12 2a10 10 0 0110 10h-2a8 8 0 00-8-8V2z"
          />
        </svg>
      ) : (
        children
      )}
    </button>
  );
};

export default LoadingButton;
